import http from 'plugins/axios'
export async function call(admin, path, data = {}, post = false) {
  let result
  try {
    result = await http[post ? 'post' : 'get']({
    url: (admin ? '/ta/admin/spot-rebate' : '/partner/spot-rebate') + path,
    data, ...(post ? { dataType: 'form' } : {})
    })
  } catch (cause) {
    // The tenant interceptor rejects confirmed business errors as their message string.
    const error = new Error('SPOT_REBATE_REQUEST_FAILED')
    error.businessFailure = typeof cause === 'string' && /^SPOT_REBATE_[A-Z_]+$/.test(cause)
    throw error
  }
  if (!result || (result.returnCode != null && result.returnCode !== 0) || (result.code != null && result.code !== 0)) {
    const error = new Error('SPOT_REBATE_REQUEST_FAILED')
    error.businessFailure = !!(result && (result.code != null || result.returnCode != null))
    throw error
  }
  return result.result !== undefined ? result.result : result.data
}
